import { SxProps, Theme } from "@mui/system";

export const HeaderWrapper: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "24px",
  gap: "24px",
  alignSelf: "stretch",
};

export const logoContainer: SxProps<Theme> = {
  width: "72px",
  height: "72px",
  backgroundColor: "#3C4949",
  borderRadius: "8px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
};

export const practiceNameTypography: SxProps<Theme> = {
  color: "#000",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "33.3px",
  fontWeight: 700,
  lineHeight: "normal",
};

export const underline: SxProps<Theme> = {
  width: "100%",
  height: "1px",
  backgroundColor: "#E5E5E5",
  boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.25)",
};
